module.exports = __webpack_public_path__ + "img/404_image.96f44776.png";